var exports = {
  "kL": "x43aef4ae--937da9--container",
  "Qs": "x43aef4ae--937da9--content",
  "DD": "x43aef4ae--937da9--title",
  "kZ": "x43aef4ae--937da9--image-wrapper",
  "Lp": "x43aef4ae--937da9--image-wrapper-inner",
  "Jq": "x43aef4ae--937da9--promo-label-wrapper",
  "VN": "x43aef4ae--937da9--close",
  "rP": "x43aef4ae--937da9--transports-wrapper",
  "G6": "x43aef4ae--937da9--rooms-info-wrapper",
  "KT": "x43aef4ae--937da9--link-button-wrapper",
};

module.exports = exports;
